// Buttons.jsx
export const PrimaryButton = (props) => (
  <button className="btn btn-primary" {...props} />
);
export const SubtleButton = (props) => (
  <button className="btn btn-subtle" {...props} />
);
export const DangerButton = (props) => (
  <button className="btn btn-danger" {...props} />
);
